(() => {
  const money = (cents, currency) => new Intl.NumberFormat('es-CL', {
    style: 'currency', currency: currency || 'CLP', maximumFractionDigits: 0
  }).format((Number(cents) || 0) / 100);

  function initProduct(root) {
    if (!root || root.dataset.anfReady === 'true') return;
    root.dataset.anfReady = 'true';
    const story = root.querySelector('[data-anf-story]');
    if (story) {
      const mobileStory = window.matchMedia('(max-width: 989px)');
      const syncStory = () => {
        story.open = !mobileStory.matches;
      };
      syncStory();
      mobileStory.addEventListener('change', syncStory);
    }
    const data = root.querySelector('[data-anf-variants]');
    const form = root.querySelector('form[action*="/cart/add"]');
    if (!data || !form) return;
    const variants = JSON.parse(data.textContent || '[]');
    const currency = root.dataset.currency || 'CLP';
    const selectors = [...root.querySelectorAll('[data-anf-option]')];
    const idInput = form.querySelector('[name="id"]');
    const button = form.querySelector('[name="add"]');
    const buttonText = button && button.querySelector('[data-anf-button-text]');
    const price = root.querySelector('[data-anf-price]');
    const compare = root.querySelector('[data-anf-compare]');
    const saving = root.querySelector('[data-anf-saving]');
    const availability = root.querySelector('[data-anf-availability]');
    const mainImage = root.querySelector('[data-anf-main-image]');

    const renderVolumePrices = (basePrice) => {
      root.querySelectorAll('[data-anf-volume-choice]').forEach((choice) => {
        const quantity = Number(choice.dataset.anfVolumeChoice) || 1;
        const discount = Number(choice.dataset.anfDiscount) || 0;
        const unitPrice = Math.floor(Number(basePrice) * (100 - discount) / 100);
        const totalPrice = unitPrice * quantity;
        const unit = choice.querySelector('[data-anf-volume-unit]');
        const total = choice.querySelector('[data-anf-volume-total]');
        if (unit) unit.textContent = `${money(unitPrice, currency)} c/u`;
        if (total) total.textContent = `Total ${money(totalPrice, currency)}`;
      });
    };

    const render = () => {
      const options = selectors.map((select) => select.value);
      const variant = variants.find((item) => item.options.every((value, index) => value === options[index])) || variants[0];
      if (!variant) return;
      idInput.value = variant.id;
      if (price) price.textContent = money(variant.price, currency);
      renderVolumePrices(variant.price);
      const hasCompare = Number(variant.compare_at_price) > Number(variant.price);
      if (compare) {
        compare.hidden = !hasCompare;
        compare.textContent = hasCompare ? money(variant.compare_at_price, currency) : '';
      }
      if (saving) {
        saving.hidden = !hasCompare;
        saving.textContent = hasCompare ? `Ahorras ${money(variant.compare_at_price - variant.price, currency)}` : '';
      }
      if (button) button.disabled = !variant.available;
      if (buttonText) buttonText.textContent = variant.available ? root.dataset.addText : root.dataset.soldText;
      if (availability) availability.textContent = variant.available ? root.dataset.availableText : root.dataset.soldText;
      if (variant.featured_image && mainImage) {
        mainImage.src = variant.featured_image.src;
        mainImage.srcset = '';
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    selectors.forEach((select) => select.addEventListener('change', render));
    root.querySelectorAll('[data-anf-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!mainImage) return;
        mainImage.src = thumb.dataset.image;
        mainImage.srcset = '';
        root.querySelectorAll('[data-anf-thumb]').forEach((item) => item.setAttribute('aria-current', 'false'));
        thumb.setAttribute('aria-current', 'true');
      });
    });
    root.querySelectorAll('[data-anf-volume-choice]').forEach((choice) => {
      choice.addEventListener('click', () => {
        const input = form.querySelector('[data-anf-volume-input]');
        if (!input) return;
        input.value = choice.dataset.anfVolumeChoice || '1';
        root.querySelectorAll('[data-anf-volume-choice]').forEach((item) => {
          const active = item === choice;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      });
    });
    render();
  }

  const init = (scope = document) => scope.querySelectorAll('[data-anf-product]').forEach(initProduct);
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
